/*
 * © 2020 Microsoft. All rights reserved.
 */

define('util/RegularButton',['pixi', 'absolute', 'util/eventhandler'],
    function (PIXI, Absolute, EventHandler) {
        var RegularButton = function (downTexture, overTexture, upTexture, label, labelOptions, handleActivate) {
            this.upTexture = new PIXI.Sprite.fromFrame(upTexture).generateTexture();
            this.downTexture = new PIXI.Sprite.fromFrame(downTexture).generateTexture();
            this.overTexture = new PIXI.Sprite.fromFrame(overTexture).generateTexture();
            this.interactive = true;
            this.onClick = new EventHandler();
            this._hasFocus = false;
            this._isActive = false;
            PIXI.Sprite.call(this, this.upTexture);
            this.bindListeners();
            if (label && labelOptions) this.initLabel(label, labelOptions);
            if (!!handleActivate) {
                this.handleActivate = handleActivate;
            }
        };

        RegularButton.prototype = Object.create(PIXI.Sprite.prototype);
        RegularButton.prototype.constructor = RegularButton;

        RegularButton.prototype.bindListeners = function () {
            this.interactive = true;
            this.buttonMode = true;

            if (Absolute.Platform.supportsTouch()) {
                this.bindTouchEvents();
                // Support mouse on laptops/desktops that have touch displays
                if (Absolute.Platform._isWindows() || (Absolute.Platform._isMac() && !Absolute.Platform._isIOS())) {
                    this.bindMouseEvents();
                }
            } else {
                this.bindMouseEvents();
            }
        };

        RegularButton.prototype.bindTouchEvents = function () {
            this.touchstart = function (evt) {
                this.setTexture(this.downTexture);
            };

            this.touchend = function (evt) {
                this.setTexture(this.upTexture);
                this.handleInputUp();
            };

            this.touchendoutside = function (evt) {
                this.setTexture(this.upTexture);
            };
        };

        RegularButton.prototype.bindMouseEvents = function () {
            this.mouseover = function (evt) {
                this.setTexture(this.overTexture);
            };
            this.mouseout = function (evt) {
                this.setTexture(this.upTexture);
            };

            this.mousedown = function (evt) {
                this.setTexture(this.downTexture);
            }.bind(this);

            this.mouseup = function (evt) {
                this.setTexture(this.upTexture);
                this.handleInputUp();
            }.bind(this);
        };

        RegularButton.prototype.initLabel = function (label, labelOptions) {
            var labelTextStyle = {
                font: labelOptions.font,
                fontFamily: labelOptions.fontFamily,
                fill: labelOptions.fill,
                align: labelOptions.align ? labelOptions.align : 'left'
            };
            var label = new PIXI.Text(label, labelTextStyle);
            this.addChild(label);
            if (labelOptions.anchor) {
                label.anchor.set(labelOptions.anchor.x, labelOptions.anchor.y);
            }
            label.position.set(labelOptions.x, labelOptions.y);
        };

        RegularButton.prototype.handleInputUp = function () {
            Absolute.AudioManager.playSound('button');
            this.onClick.handleEvent(this);
        };

        RegularButton.prototype._focusChanged = function() {
            if (this._hasFocus) {
                this.setTexture(this.overTexture);
            } else {
                this.setTexture(this.upTexture);
            }
        }

        Object.defineProperty(RegularButton.prototype, "focus", {
            get: function () {
                return this._hasFocus;
            },
            set: function (value) {
                this._hasFocus = value;
                this._focusChanged();
                return value;
            }
        });

        Object.defineProperty(RegularButton.prototype, "active", {
            get: function () {
                return this._isActive;
            },
            set: function (value) {
                this._isActive = value;
                return value;
            }
        });

        return RegularButton;
    });

